import React, { useEffect, useState, useContext } from 'react';
import { Route, Routes, useNavigate, } from 'react-router-dom';
import loginService from './paginas/login/service/login.service';
import Cabecalho from './layout/cabecalho/Cabecalho';
import Login from '../app/paginas/login/Login';
import PaginaInicial from '../app/paginas/paginaInicial/PaginaInicial';
import CreateUsuario from '../app/paginas/usuario/CreateUsuario';
import EditUsuario from '../app/paginas/usuario/EditUsuario';
import ListUsuarios from '../app/paginas/usuario/ListUsuarios';
import { UserContext } from './contexts/UserContext';
import FormularioPeticao from './paginas/peticoes/FormularioPeticao';
import AcompanharNumeroFormularioPeticao from './paginas/peticoes/AcompanharNumeroFormularioPeticao';
import ListFormularioPeticao from './paginas/peticoes/ListFormularioPeticao';
import VerFormularioPeticao from './paginas/peticoes/VerFormularioPeticao';
import ResumoFormularioPeticao from './paginas/peticoes/ResumoFormularioPeticao';
import GerenciamentoAplicacao from './paginas/gerenciamentoAplicacao/GerenciamentoAplicacao';
import VerificarEmailUsuario from './paginas/usuario/VerificarEmailUsuario';
import ResetPasswordUsuario from './paginas/usuario/ResetPasswordUsuario';
import FormularioRelatorio from './paginas/peticoes/FormularioRelatorio';
import ListGeraRelatorio from './paginas/peticoes/ListGeraRelatorio';

const Routs = () => {

    const [isToken, setIsToken] = useState(false);
    const [userRole, setUserRole] = useState(false);
    const { user_role } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        loginService.observable.onToken().subscribe((token: any) => {
            if (token) {
                setIsToken(true);
            }
            if (token == null) {
                setIsToken(false);
            }
        });
        loginService.observable.setToken(loginService.getToken());

    }, []);

    useEffect(() => {
        if (user_role) {
            setUserRole(true);
            if (user_role != 1 && user_role != 2) {
                setUserRole(false);
                navigate('/pagina-inicial');
            }
        }
    }, [user_role]);

    return (
        <div >
            <Cabecalho />
            <div>
                <Routes>
                    <Route path='/login' element={<Login />} />
                    <Route path='/' element={<FormularioPeticao />} />
                    <Route path='acompanhar-peticao' element={<AcompanharNumeroFormularioPeticao />} />
                    <Route path='/formulario-peticao/acompanhar-denuncia/resumo/*' element={<ResumoFormularioPeticao />} />
                    <Route path='/email/verify/:id/:hash/:expires/:signature' element={<VerificarEmailUsuario />} />
                    <Route path='/reset-password/' element={<ResetPasswordUsuario />} /> 
                    <Route path='/list-gera-relatorio/' element={<ListGeraRelatorio />} /> 

                    {isToken &&
                        <>
                            {userRole &&
                                <>
                                    <Route path='/create-usuario' element={<CreateUsuario />} />
                                    <Route path='/list-usuario' element={<ListUsuarios />} />
                                    <Route path='/edit-usuario/*' element={<EditUsuario />} />
                                </>
                            }

                            <Route path='/pagina-inicial' element={<PaginaInicial />} />

                            <Route path='/list-formulario-peticao' element={<ListFormularioPeticao />} />
                            <Route path='/ver-formulario-peticao/*' element={<VerFormularioPeticao />} />
                            <Route path='/gerenciamento-aplicacao' element={<GerenciamentoAplicacao />}  />

                            <Route path='/formulario-relatorio' element={<FormularioRelatorio />} />

                            <Route path='/teste-formulario-relatorio' element={<ListGeraRelatorio />} />
                        </>
                    }
                </Routes>
            </div>
        </div>
    )
}
export default Routs;
